const hasSpecialChar = (value: string) => /^(?=.*[=$@$!#%*?&+#._-]){1}/.test(value);

export default hasSpecialChar;
